import React from 'react';
import { VscGame } from 'react-icons/vsc';
import { AiOutlineTrophy } from 'react-icons/ai';
import { FiClock } from 'react-icons/fi';
import { TfiMedall } from 'react-icons/tfi';
import medalPoints from './img/medal-points.svg';
import { useWeeklyChallenge } from 'src/app/hooks/useWeeklyChallenge';
import { useQuery } from 'jsonapi-react';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import {
  ChallengeModalSection,
  ChallengeSuccess,
  ChallengeSuccessBody,
  ChallengeSuccessHeader,
  ChallengeSuccessKPI,
  ChallengeSuccessKPIIcon,
  ChallengeSuccessKPIList,
  ChallengeSuccessKPITitle,
  ChallengeSuccessKPIValue,
  ChallengeSuccessMessage,
  ChallengeSuccessMessageSubtitle,
  ChallengeSuccessMessageTitle,
  ChallengeSuccessPoints,
  ChallengeSuccessStars,
  ChallengeSuccessSubtitle,
  ChallengeSuccessTitle,
  ChallengeSuccessTotal
} from '@/components/custom/challenge';

export default function WeekChallengeStepSuccess(props) {
  const { onClose } = props;
  const { currentChallenge, rightAnswers, challengeCurrentStatus } = useWeeklyChallenge();

  const { data: position } = useQuery('/challenge_attempt_items/position');
  const { data: time } = useQuery(`challenges/${currentChallenge?.id}/challenge_attempt_items`);
  let timeFormat;

  if (time) {
    const totalSeconds = Math.floor(time[0]?.duration);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    timeFormat = `${formattedMinutes}:${formattedSeconds}`;
  }

  return (
    <ChallengeModalSection variant="success">
      <ChallengeSuccess>
        <ChallengeSuccessHeader>
          <AvatarWrapper
            size="md"
            src={currentChallenge?.image}
            text="foto"
            className="mb-3"
          />

          <ChallengeSuccessTitle>{currentChallenge?.title}</ChallengeSuccessTitle>
          <ChallengeSuccessSubtitle>
            <VscGame /> Desafio
          </ChallengeSuccessSubtitle>
        </ChallengeSuccessHeader>

        <ChallengeSuccessBody>
          <ChallengeSuccessMessage>
            <ChallengeSuccessMessageTitle>É isso aí!</ChallengeSuccessMessageTitle>
            <ChallengeSuccessMessageSubtitle>Seu esforço valeu a pena</ChallengeSuccessMessageSubtitle>
          </ChallengeSuccessMessage>

          <ChallengeSuccessPoints>
            <ChallengeSuccessTotal>{challengeCurrentStatus?.score}</ChallengeSuccessTotal>
            <img
              src={medalPoints}
              alt="medalha de pontos"
            />
            <ChallengeSuccessStars />
          </ChallengeSuccessPoints>

          <ChallengeSuccessKPIList>
            <ChallengeSuccessKPI>
              <ChallengeSuccessKPITitle>
                Acertos <TfiMedall />
              </ChallengeSuccessKPITitle>
              <ChallengeSuccessKPIValue>{rightAnswers}</ChallengeSuccessKPIValue>
            </ChallengeSuccessKPI>
            <ChallengeSuccessKPI>
              <ChallengeSuccessKPITitle>
                Tempo <FiClock />
              </ChallengeSuccessKPITitle>
              <ChallengeSuccessKPIValue>{timeFormat}</ChallengeSuccessKPIValue>
            </ChallengeSuccessKPI>
            <ChallengeSuccessKPI>
              <ChallengeSuccessKPITitle>
                Posição <AiOutlineTrophy />
              </ChallengeSuccessKPITitle>
              <ChallengeSuccessKPIValue>
                <ChallengeSuccessKPIIcon>
                  <AiOutlineTrophy />
                </ChallengeSuccessKPIIcon>{' '}
                {position?.position}º lugar
              </ChallengeSuccessKPIValue>
            </ChallengeSuccessKPI>
          </ChallengeSuccessKPIList>

          <Button
            variant="outline"
            fullWidth
            onClick={onClose}
          >
            Voltar para desafios
          </Button>
        </ChallengeSuccessBody>
      </ChallengeSuccess>
    </ChallengeModalSection>
  );
}
